import { clientApi } from '@phoenix/clientApi';
import { getDistanceFromLatLngInKm } from '@phoenix/helpers/store-helper';

export default {
  data: () => ({
    nearStores: [],
  }),

  computed: {
    hasStoresNearMe() {
      return this.nearStores && this.nearStores.length > 0;
    },
  },

  methods: {
    setPositionBtnLoader(loading) {
      if (loading) {
        Toolkit.helpers.buttons.addLoadingState(this.$refs.positionBtn, { text: this.$t('StoreSearch.geolocating') });
      } else {
        Toolkit.helpers.buttons.removeLoadingState(this.$refs.positionBtn);
      }
    },

    onCurrentPositionError(error) {
      this.setPositionBtnLoader(false);
      let message = this.$t('StoreSearch.error.UNKNOWN_ERROR');
      switch (error.code) {
        case error.PERMISSION_DENIED:
          message = this.$t('StoreSearch.error.PERMISSION_DENIED');
          break;
        case error.POSITION_UNAVAILABLE:
          message = this.$t('StoreSearch.error.POSITION_UNAVAILABLE');
          break;
        case error.TIMEOUT:
          message = this.$t('StoreSearch.error.TIMEOUT');
          break;
      }
      window.Phoenix.toaster.notify({
        type: 'danger',
        text: message,
      });
    },

    async onCurrentPositionSuccess(position) {
      const params = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        boutiqueOnly: true,
      };

      const { data } = await clientApi.get(window.route('api.search.stores.locator'), {
        params,
      });

      this.setPositionBtnLoader(false);

      this.nearStores = data.data
        .map((store) => ({
          ...store,
          title: store?.name,
          address: store?.fullAddress,
          image: store.rokkaImg,
          distance: Math.round(getDistanceFromLatLngInKm(params.lat, params.lng, store.lat, store.lng)),
        }))
        .filter((store, index) => index < this.maxItems);
    },

    useMyPosition() {
      if (navigator.geolocation) {
        this.setPositionBtnLoader(true);
        navigator.geolocation.getCurrentPosition(this.onCurrentPositionSuccess, this.onCurrentPositionError);
      } else {
        window.Phoenix.toaster.notify({
          type: 'danger',
          text: this.$t('StoreSearch.error.NOT_SUPPORTED'),
        });
      }
    },
  },
};
